import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filter, lowerCase } from "lodash";
import { useTranslation } from "react-i18next";
import { getConfig } from "../../util/configUtil";
import {
    announcements,
    loadAnnouncements,
} from "../../store/reducers/announcement";
import { TimerCountUp } from "../../controls/agyle/timer";
import { useStyles } from "../../components/header/announcements";
import { Slide, Grid } from "@mui/material";
import InformationBox from "../../components/other/informationBox";

export default function EstimatedWaitingTimeNotifications() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { t } = useTranslation();

    const announcementsObject = useSelector(announcements);

    const [peekIndex, setPeekIndex] = useState(0);
    const [visible, setVisible] = useState(true);

    const defaultNotificationTimeVisibility = getConfig(
        "modules.admin.edWaitAnnouncementsRotation",
        20,
    );

    const viewFiltered = useMemo(
        () => filter(announcementsObject, { system: "ED WAIT", enabled: true }),
        [announcementsObject],
    );

    useEffect(() => {
        if (viewFiltered.length >= 2) {
            const interval = setInterval(
                () => {
                    setVisible(false);

                    setTimeout(() => {
                        let idx = peekIndex >= viewFiltered.length - 1 ? 0 : peekIndex + 1;

                        setPeekIndex(idx);
                    }, 500);
                },
                parseInt(defaultNotificationTimeVisibility) * 1000,
            );

            return () => {
                setVisible(true);
                clearInterval(interval);
            };
        }
    }, [viewFiltered, peekIndex, defaultNotificationTimeVisibility]);

    const currentNotification = useMemo(
        () => viewFiltered.at(peekIndex),
        [peekIndex, viewFiltered],
    );

    useEffect(() => {
        dispatch(loadAnnouncements());
        const iid = setInterval(() => dispatch(loadAnnouncements()), 60000);
        return () => {
            clearInterval(iid);
        };
    }, []);

    const currNotificationType =
        lowerCase(currentNotification?.colour) === "note"
            ? "tip"
            : lowerCase(currentNotification?.colour || 'info');

    return (
        <Grid container>
            {currentNotification && (
                <Slide in={visible} direction="right">
                    <Grid item xs={12}>
                        <InformationBox
                            label={t("Announcement")}
                            type={currNotificationType}
                        >
                            <Grid item style={{ fontSize: "xx-large" }}>
                                {currentNotification?.text}
                            </Grid>

                            {currentNotification?.countdownTo && (
                                <Grid item>
                                    <div
                                        className={classes.announcementTitle}
                                        style={{ fontSize: "xx-large" }}
                                    >
                                        <TimerCountUp
                                            time={currentNotification?.countdownTo}
                                            limit={0}
                                            upperLimit={1}
                                            limitMessage={t("-Countdown End-")}
                                            countDown
                                        />
                                    </div>
                                </Grid>
                            )}
                        </InformationBox>
                    </Grid>
                </Slide>
            )}
        </Grid>
    );
}
